<template>
    <div class="container" v-if="type == 'earphone'">
        <div class="main-container">
            <div class="pic">
                <img src="./img/earphone.png" alt="">
            </div>
            <div>
                <av-line
                        :line-width="2"
                        line-color="#248cfa"
                        :audio-src="music"
                ></av-line>
            </div>
        </div>
        <div class="tips">
            <div style="text-align: left; line-height: 22px;font-size: 18px;">
                如可以 <span style="color: green;font-weight: 700;">清晰</span> 听到示例录音请点击“下一步”<br>
                如 <span style="color: red;font-weight: 700;">听不到</span> 示例录音请检查您的耳机
            </div>
        </div>
<!--        <button @click="checkMic">测试麦克风</button>-->
<!--        <button @click="stopCheckMic">停止测试</button>-->

<!--        <audio id='audio'></audio>-->
<!--        <av-media type="frequ" :media="media" />-->
        <div class="footer">
            <el-button @click="finish">关闭</el-button>
            <el-button @click="nextStep('micro')" type="primary">下一步 ></el-button>
        </div>
    </div>
    <div class="container" v-else>
        <div class="main-container">
            <div class="pic">
                <img src="./img/micro.png" alt="">
            </div>
            <div v-if="defaultDevices.mic">
                <audio
                        id='audio'></audio>
                <av-media
                        line-color="#248cfa"
                        type="frequ" :media="media" />
                <div style="text-align: center;color: #248cfa;"><i class="el-icon el-icon-mic"></i>请对着麦克风说话</div>
            </div>
            <div v-else style="text-align: center;width: 50%;">
                未检测到麦克风
            </div>
        </div>
        <div class="tips">
            <div style="text-align: left; line-height: 22px;font-size: 18px;">
                如可以 <span style="color: green;font-weight: 700;">清晰</span> 听到自己的声音请点击“完成”并结束调试<br>
                如 <span style="color: red;font-weight: 700;">听不到</span> 自己的声音请检查您的麦克风
            </div>
        </div>
        <!--        <button @click="checkMic">测试麦克风</button>-->
        <!--        <button @click="stopCheckMic">停止测试</button>-->

        <div class="footer">
            <el-button @click="nextStep('earphone')"> < 上一步</el-button>
            <el-button @click="finish" type="primary">完成</el-button>
        </div>
    </div>
</template>

<script>
    let a = require('./audio/file_example_MP3_1MG.mp3')
    export default {
        name: "checkEarPhone",
        props: ['defaultDevices','debugType'],
        data() {
            return {
                show: true,
                type: 'earphone',
                media: null,
                music: a
            }
        },
        watch: {
            debugType: {
                handler(val) {
                    console.log(val);
                    this.type= val
                },
                immediate: true
            },
            type:  {
                handler(val) {
                    if(val == 'micro') {
                        this.checkMic()
                    }
                },
                immediate: true
            }
        },
        mounted() {
        },
        methods: {
            nextStep(type) {
                this.type = type
                this.$emit('changeType',type)
            },
            finish() {
                this.type = 'earphone'
                this.stopCheckMic()
                this.$emit('close')
            },
            shutDown() {
                this.show = false
            },
            stopCheckMic() {
                navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: false
                }).then(stream => {
                    console.log(stream);
                    if (window.stream) {//先关闭之前已经打开的设备
                        window.stream.getTracks().forEach(track => {
                            console.log(track);
                            track.stop();
                        });
                    }
                })
            },
            checkMic() {
                navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: false
                }).then(stream => {
                    console.log(stream);
                    if (window.stream) {//先关闭之前已经打开的设备
                        window.stream.getTracks().forEach(track => {
                            track.stop();
                        });
                    }
                    this.media = stream
                    var audio = document.querySelector("#audio");
                    try {
                        window.stream = stream;
                        audio.srcObject = stream;
                    } catch (error) {
                        audio.src = window.URL.createObjectURL(stream);//老的播放方式
                    }
                    audio.play();
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

    .main-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .pic {
            width: 50%;
            img {
                width: 100%;
            }
        }
        
    }
    .tips {
        padding: 20px 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .footer {
        margin-top: 20px;
        text-align: right;
    }
</style>